<template>
	<div
		class="stage"
		v-if="showCard"
	>
		<div class="stages-arrow arrow">
			<img
				src="https://static.bimcc.com/openim/16641634199181B77A9F6676A97194FDB54C90DD0E00A.png"
				class="stage-circle"
			/>
		</div>
		<section class="stage-group first">
			<div class="card">
				<div class="icon-box">
					<img
						:src="icon1"
						class="icon"
					/>
				</div>
				<h6>拖拉拽建模</h6>
				<div
					class="icon-title"
					v-for="item in firstRowList"
					:key="item.id"
				>
					<el-row>
						<el-col
							:span="6"
							class="center"
							><img
								:src="item.icon"
								class="icon"
							/>
						</el-col>
						<el-col :span="18">
							<p>{{ item.text }}</p></el-col
						>
					</el-row>
				</div>
			</div>
			<div class="line-box first-height">
				<img
					:src="line"
					class="line"
				/>
			</div>
			<div class="ellipse-box">
				<img
					:src="group"
					class="ellipse"
				/>
			</div>
			<h6>第一阶段</h6>
		</section>
		<section class="stage-group second">
			<div class="card">
				<div class="icon-box">
					<img
						:src="icon2"
						class="icon"
					/>
				</div>
				<h6>服务效率化</h6>
				<div
					class="icon-title"
					v-for="item in secondRowList"
					:key="item.id"
				>
					<el-row>
						<el-col
							:span="6"
							class="center"
							><img
								:src="item.icon"
								class="icon"
							/>
						</el-col>
						<el-col :span="18">
							<p>{{ item.text }}</p></el-col
						>
					</el-row>
				</div>
			</div>
			<div class="line-box second-height">
				<img
					:src="line"
					class="line"
				/>
			</div>
			<div class="ellipse-box">
				<img
					:src="group"
					class="ellipse"
				/>
			</div>
			<h6>第二阶段</h6>
		</section>
		<section class="stage-group third">
			<div class="card">
				<div class="icon-box">
					<img
						:src="icon3"
						class="icon"
					/>
				</div>
				<h6>应用场景化</h6>
				<div
					class="icon-title"
					v-for="item in thirdRowList"
					:key="item.id"
				>
					<el-row>
						<el-col
							:span="6"
							class="center"
							><img
								:src="item.icon"
								class="icon"
							/>
						</el-col>
						<el-col :span="18">
							<p>{{ item.text }}</p></el-col
						>
					</el-row>
				</div>
			</div>
			<div class="line-box third-height">
				<img
					:src="line"
					class="line"
				/>
			</div>
			<div class="ellipse-box">
				<img
					:src="group"
					class="ellipse"
				/>
			</div>
			<h6>第三阶段</h6>
		</section>
		<section class="stage-group fourth">
			<div class="card">
				<div class="icon-box">
					<img
						:src="icon4"
						class="icon"
					/>
				</div>
				<h6>数据全域化</h6>
				<div
					class="icon-title"
					v-for="item in fourthRowList"
					:key="item.id"
				>
					<el-row>
						<el-col
							:span="6"
							class="center"
							><img
								:src="item.icon"
								class="icon"
							/>
						</el-col>
						<el-col :span="18">
							<p>{{ item.text }}</p></el-col
						>
					</el-row>
				</div>
			</div>
			<div class="line-box fourth-height">
				<img
					:src="line"
					class="line"
				/>
			</div>
			<div class="ellipse-box">
				<img
					:src="group"
					class="ellipse"
				/>
			</div>
			<h6>第四阶段</h6>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Stage',
	components: {},
	props: {},
	data() {
		return {
			distanceY: null, //滚动条长度
			showCard: false,
			line: 'https://static.bimcc.com/openim/Line%201%20%281%29642221149FF2D57F7236501F24AD06EE.png',
			group: 'https://static.bimcc.com/openim/Group%204A031B54D934CD3570AC3575BD5148600.png',
			icon1: 'https://static.bimcc.com/openim/Group%2014649285AD2FF5D4ACD6EB0F235480B85A96.png',
			icon2: 'https://static.bimcc.com/openim/Group%201467851A36D57D3D1B91EFB7A6F90FC87418.png',
			icon3: 'https://static.bimcc.com/openim/Frame%20%2818%29C452E1729825B95FEF5180CE64721B38.png',
			icon4: 'https://static.bimcc.com/openim/Group%201470DBCB47A067E042C48085B038EF1BCB09.png',
			firstRowList: [
				{
					id: 0,
					text: '元数据建模',
					icon: 'https://static.bimcc.com/openim/Frame%20%2819%299152A7BA5C199C33E2B28C5A7B401D81.png'
				},
				{
					id: 1,
					text: '无代码渲染',
					icon: 'https://static.bimcc.com/openim/Frame%20%2820%2995971BEE48F4901B9401260DA1EA6DBF.png'
				},
				{
					id: 2,
					text: '图形化ETL视图',
					icon: 'https://static.bimcc.com/openim/Frame%20%2821%29733618809826EA900BE51D3F76FA24C2.png'
				},
				{
					id: 3,
					text: '可视化表单',
					icon: 'https://static.bimcc.com/openim/Group%2013889B794E47B4BE6A470F75C244DAE1E001.png'
				},
				{
					id: 4,
					text: '逻辑蓝图',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/1c604994a6ab0559dddaf8c3c247b9d6.png'
				}
			],
			secondRowList: [
				{
					id: 0,
					text: '多终端采集填报',
					icon: 'https://static.bimcc.com/openim/Frame%20%2824%29FC0B43ECC8292952D1BD464CAF8D2369.png'
				},
				{
					id: 1,
					text: '高效相应反馈',
					icon: 'https://static.bimcc.com/openim/Frame%20%2825%29F118645CA3A3E8ADB16E0D4A9346C66E.png'
				},
				{
					id: 2,
					text: '智能化数据分析',
					icon: 'https://static.bimcc.com/openim/Frame%20%2826%2979ABB47E422F6329C2130431F7E6D127.png'
				},
				{
					id: 3,
					text: '待办到期提醒',
					icon: 'https://static.bimcc.com/openim/Frame%20%2827%2942790B55CECEE3FC1638B3579C4107F5.png'
				},
				{
					id: 4,
					text: '多渠道消息通知',
					icon: 'https://static.bimcc.com/openim/Frame%20%2828%293738A5A8753D475547305218D56F9384.png'
				}
			],
			thirdRowList: [
				{
					id: 0,
					text: '跨组织多方协同',
					icon: 'https://static.bimcc.com/openim/Frame%20%2829%29B746948C106311DF3F14BBE38B747E2A.png'
				},
				{
					id: 1,
					text: '大型组织一站式审批',
					icon: 'https://static.bimcc.com/openim/Frame%20%2830%2996C0E2C4867317C9CCE29197FD648A05.png'
				},
				{
					id: 2,
					text: '中国特色式审批流',
					icon: 'https://static.bimcc.com/openim/Frame%20%2831%29B768798C4B4879B6949BEADEFFCB3FEF.png'
				},
				{
					id: 3,
					text: 'BIMGIS调试感知',
					icon: 'https://static.bimcc.com/openim/Frame%20%2832%29834E2DB53E8C80873C6B55387DACDDB2.png'
				},
				{
					id: 4,
					text: '智慧工地3D实景监控',
					icon: 'https://static.bimcc.com/openim/Frame%20%2833%29372A43115E91A5300E934D626C2421B4.png'
				}
			],
			fourthRowList: [
				{
					id: 0,
					text: '全平台数据接入',
					icon: 'https://static.bimcc.com/openim/Frame%20%2835%296DC18777B9EE190D2538B4738A4CA3D8.png'
				},
				{
					id: 1,
					text: '全平台数据结构化',
					icon: 'https://static.bimcc.com/openim/Frame%20%2836%29E80C7B35554E2C7B574AEE6AB354A66C.png'
				},
				{
					id: 2,
					text: '元数据多数据源加工',
					icon: 'https://static.bimcc.com/openim/Frame%20%2837%29C4456B722E0767F3438864D2CDDBF708.png'
				},
				{
					id: 3,
					text: '业务数据可视化分析',
					icon: 'https://static.bimcc.com/openim/Frame%20%2838%29811C290D9ED4FD29E7A5BE326373D61C.png'
				},
				{
					id: 4,
					text: '跨表图形数据视图',
					icon: 'https://static.bimcc.com/openim/Frame%20%2839%29FA5FCDFF4CD8FC3FEB910C8E072AA012.png'
				}
			]
		};
	},
	mounted() {
		window.addEventListener('scroll', this.windowSrcoll, true);
	},
	methods: {
		/**
		 * @desc: 监听滚动到指定位置开始动画效果
		 */
		windowSrcoll(event) {
			this.$nextTick(() => {
				this.distanceY = event.target.scrollTop;
				if (this.distanceY > 1333) {
					this.showCard = true;
				}
			});
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.windowSrcoll, true);
	}
};
</script>

<style lang="less" scoped>
.arrow {
	animation: extend 0.5s 1;
}
@keyframes extend {
	0% {
		width: 0;
		opacity: 0;
		transition: 0.5s 1;
		pointer-events: none;
	}
	100% {
		width: 1052px;
		opacity: 1;
		pointer-events: all;
		transition-delay: 1s;
	}
}
.first {
	opacity: 0;
	animation: first 0.5s 1;
	animation-delay: 0.5s;
	animation-fill-mode: forwards;
}
@keyframes first {
	0% {
		opacity: 0;
		transform: translate(-170px, 100px) scale3d(0.8, 0.8, 1);
	}
	100% {
		opacity: 1;
		transform: translate(0px, 0px);
	}
}
.second {
	opacity: 0;
	animation: second 0.5s 1;
	animation-delay: 1s;
	animation-fill-mode: forwards;
}
@keyframes second {
	0% {
		opacity: 0;
		transform: translate(-110px, 100px) scale3d(0.8, 0.8, 1);
	}
	100% {
		opacity: 1;
		transform: translate(0px, 0px);
	}
}
.third {
	opacity: 0;
	animation: third 0.5s 1;
	animation-fill-mode: forwards;
	animation-delay: 1.5s;
}
@keyframes third {
	0% {
		opacity: 0;
		transform: translate(-70px, 100px) scale3d(0.8, 0.8, 1);
	}
	100% {
		opacity: 1;
		transform: translate(0px, 0px);
	}
}
.fourth {
	opacity: 0;
	animation: fourth 0.5s 1;
	animation-delay: 2s;
	animation-fill-mode: forwards;
}
@keyframes fourth {
	0% {
		opacity: 0;
		transform: translate(0px, 100px) scale3d(0.8, 0.8, 1);
	}
	100% {
		opacity: 1;
		transform: translate(0px, 0px);
	}
}
.first-height {
	height: 100px;
}
.second-height {
	height: 96px;
}
.third-height {
	height: 93px;
}
.fourth-height {
	height: 84px;
}
.show {
	opacity: 1;
	transform: translate(0px, 0px);
}
.first {
	padding-top: 13px;
	box-sizing: border-box;
}
.second {
	padding-top: 127px;
	box-sizing: border-box;
}
.third {
	padding-top: 116px;
	box-sizing: border-box;
}
.fourth {
	padding-top: 12px;
	box-sizing: border-box;
}
.stage {
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 1200px;
	height: 100%;
	padding: 0 25px;
	box-sizing: border-box;
	.stages-arrow {
		position: absolute;
		left: 100px;
		top: 130px;
		overflow: hidden;
		width: 1052px;
		height: 589px;
		.stage-circle {
			width: 100%;
			border-style: none;
			vertical-align: middle;
		}
	}
	.stage-group {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 234px;
		height: 321px;
		.card {
			width: 234px;
			height: 321px;
			padding: 14px 0 0 14px;
			box-sizing: border-box;
			border-radius: 4px;
			box-shadow: 2px 2px 9px #c4d2e4;
			background: linear-gradient(180deg, #ebf4ff 0%, #fefeff 100%);
			.icon-box {
				width: 54px;
			}
			h6 {
				padding: 14px 0 16px 0;
				box-sizing: border-box;
				color: #3d3d3d;
				font-family: 'Source Han Sans CN';
				font-style: normal;
				font-weight: 500;
				font-size: 18px;
				line-height: 27px;
			}
			.icon-title {
				.center {
					text-align: center;
				}
				p {
					padding-bottom: 10px;
					box-sizing: border-box;
					color: #3d3d3d;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
				}
				&:last-child {
					padding-bottom: 14px;
					box-sizing: border-box;
				}
			}
		}
		.line-box {
			width: 5px;
			.line {
				height: 100%;
			}
		}
		.ellipse-box {
			width: 38px;
			height: 38px;
			z-index: 9999;
			.ellipse {
				height: 100%;
			}
		}
		h6 {
			padding-top: 12px;
			box-sizing: border-box;
			color: #2b7bf7;
			font-family: 'Source Han Sans CN';
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			line-height: 24px;
		}
	}
}
</style>
